export default {
  type: {
    ERROR: "ERROR",
    WARNING: "WARNING",
    SUCCESS: "SUCCESS",
  },
};
